<template>
  <div>
    <ul class="file-list">
      <li @click="select"
        @dblclick="next"
        @touchstart="touchstart"
        role="button"
        tabindex="0"
        :aria-label="item.name"
        :aria-selected="selected == item.url"
        :key="item.handle" v-for="item in items"
        :data-url="item.url">{{ item.name }}</li>
    </ul>

    <p>{{ $t('prompts.currentlyNavigating') }} <code>{{ nav }}</code></p>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { files, utils } from '@/api';
import { ROUTES } from '@/router';

export default {
  name: 'file-list',
  props: ['handles'],
  data: function () {
    return {
      items: [],
      touches: {
        id: '',
        count: 0
      },
      selectedElement: null,
      current: window.location.pathname,
      currentHandle: 0,
      rootPath: '',
      node: null
    };
  },
  computed: {
    ...mapState([ 'req', 'selected']),
    ...mapGetters([
      'isSharedDrive',
    ]),
    nav () {
      return decodeURIComponent(utils.removePrefix(this.current));
    }
  },
  async mounted () {
    if (this.req.items[this.selected[0]].type !== Module.NodeType.SHARED_DRIVE_ROOT.value || (this.isSharedDrive && window.location.hash !== '')) {
      const url = this.req.url;
      console.log('Initializing file list');
      if (url.startsWith('/sec')) {
        this.rootPath = decodeURIComponent(utils.removePrefix(url)).substr(0, 15);
      } else if (url.startsWith('/shdd')) {
        this.rootPath = '//shdd/';
        //this.rootPath = decodeURIComponent(utils.removePrefix(url)).substr(0, 16);
      } else {
        this.rootPath = '/';
      }
  
      if (url.startsWith('/bin')) {
        let node = await ibb.getRootNode(Module.NodeType.CLOUD_ROOT.value);
        this.node = node.node;
      } 
  
      if (this.$route.name === ROUTES.DRIVE) {
        files.fetch(url, Module.SortOrderType.SORT_ORDER_DEFAULT.value, ibbLink)
        .then(this.fillOptions)
        .catch(this.$showError);
      } else {
        files.fetch(url)
        .then(this.fillOptions)
        .catch(this.$showError);
      }
    } else {
      this.fillOptions(this.req);
    }
  },
  methods: {
    async fillOptions (req) {
      let nodeItems = [];
      this.items = [];
      if (this.req.items[this.selected[0]].type !== Module.NodeType.SHARED_DRIVE_ROOT.value || req.url !== '/shdd') {
        // Sets the current path and resets
        // the current items.
  
        if (this.node !== null) {
          this.current = '/';
          this.currentHandle = this.node.handle;
          nodeItems = await ibb.getChildFolders(this.node.handle);
        } else {
          this.current = req.url;
          this.currentHandle = req.handle;
        }
  
        this.$emit('update:selected', this.currentHandle);
  
        // If the path isn't the root path,
        // show a button to navigate to the previous
        // directory
        if (this.req.nodeType === Module.NodeType.SHARED_DRIVE_ROOT.value && this.req.virtualParentHandle !== '') {
          this.items.push({
            name: '..',
            url: req.virtualParentHandle
          });
        } else if (this.req.nodeType === Module.NodeType.SHARED_DRIVE_ROOT.value && this.req.virtualParentHandle === '') {

          this.items.push({
            name: '..',
            url: '/shdd'
          });
        } else if (decodeURIComponent(utils.removePrefix(this.current)) !== this.rootPath ) {
          this.items.push({
            name: '..',
            url: req.parentHandle
          });
        }
  
        // If this folder is empty, finish here.
        if (req.items === null) return;
      } else {
        this.$emit('update:selected', '');
      }

      // Otherwise we add every directory to the
      // move options.
      if (this.node !== null) {
        for (let item of nodeItems.nodeList) {
          this.items.push({
            name: item.name,
            url: item.handle
          });
        }
        this.node = null;
      } else {
        for (let item of req.items) {
          let flag = false;
          if ((!item.isDir && this.req.items[this.selected[0]].type !== Module.NodeType.SHARED_DRIVE_ROOT.value) || 
          (this.req.items[this.selected[0]].type === Module.NodeType.SHARED_DRIVE_ROOT.value && item.type !== Module.NodeType.SHARED_DRIVE_ROOT.value)
          || item.handle === this.req.items[this.selected[0]].handle) continue;

          if (this.handles !== undefined) {
            for (let handle of this.handles) {
              if (item.handle !== handle) {
                flag = false;
              } else {
                flag = true;
                break;
              }
            }
          }
          
          if (!flag) {
            this.items.push({
              name: item.name,
              url: item.handle
            });
          }
        }
      }
    },
    next: async function (event) {
      // Retrieves the URL of the directory the user
      // just clicked in and fill the options with its
      // content.
      let uri = event.currentTarget.dataset.url;
      if (uri !== '/shdd') {
        console.log('Opening ' + uri);

        if (this.$route.name === ROUTES.DRIVE) {
          files.fetchId(uri, Module.SortOrderType.SORT_ORDER_DEFAULT.value, ibbLink)
          .then(this.fillOptions)
          .catch(this.$showError);
        } else {
          files.fetchId(uri)
          .then(this.fillOptions)
          .catch(this.$showError);
        }
      } else {
        let sharedDrives = await ibb.getSharedDrives();
        if (this.$route.name === ROUTES.MY_SHARED_DRIVES) {
          sharedDrives = sharedDrives.nodeList.filter(item => !item.external && item.virtualParentHandle === '' && !item.archived && !item.name.startsWith('IBB_'));
        } else if (this.$route.name === ROUTES.SHARED_WITH_ME) {
          sharedDrives = sharedDrives.nodeList.filter(item => item.external && item.virtualParentHandle === '');
        } else if (this.$route.name === ROUTES.ARCHIVED) {
          sharedDrives = sharedDrives.nodeList.filter(item => !item.external && item.virtualParentHandle === '' && item.archived);
        }
        let res = {
          url: '/shdd',
          items: sharedDrives,
        }; 
        this.fillOptions(res);
      }
    },
    touchstart (event) {
      if (!/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
        return;
      }

      let url = event.currentTarget.dataset.url;

      // In 300 milliseconds, we shall reset the count.
      setTimeout(() => {
        this.touches.count = 0;
      }, 300);

      // If the element the user is touching
      // is different from the last one he touched,
      // reset the count.
      if (this.touches.id !== url) {
        this.touches.id = url;
        this.touches.count = 1;
        return;
      }

      this.touches.count++;

      // If there is more than one touch already,
      // open the next screen.
      if (this.touches.count > 1) {
        event.preventDefault();
        this.next(event);
      }
    },
    select: function (event) {
      // If the element is already selected, unselect it.
      if (this.selectedElement === event.currentTarget.dataset.url) {
        this.selectedElement = null;
        this.$emit('update:selected', this.currentHandle);
        return;
      }

      // Otherwise select the element.
      this.selectedElement = event.currentTarget.dataset.url;
      this.$emit('update:selected', this.selectedElement);
    }
  }
};
</script>
